import { useAuth } from 'app/pages/module/auth'
import React from 'react'
import { Trash2 } from 'lucide-react'

export const ActionBtn = (props) => {
  const {userType} = useAuth()
  return (
  <>
    <div className='flex items-center space-x-4'>
                <div className='border border-neutral-200 rounded-lg inline-flex w-auto items-center'>
             {((userType==='company') || (userType==='supervisor' && props?.editPermission)) &&
                  <div onClick={props.editonClick} className='py-1.5 px-2 border-r border-neutral-200 cursor-pointer text-black hover:text-[#0078ae] hover:bg-[#d6f2ff] hover:ring-2 hover:ring-[#0078ae] hover:rounded-l-lg hover:border-r-[#0078ae]'>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-6">
  <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125" />
</svg>

</div>
}
{((userType==='company') || (userType==='supervisor' && props?.deletePermission))  &&
<div onClick={props.rejectonClick} className='py-1.5 px-2 cursor-pointer text-black hover:text-[#a9252b] hover:bg-[#FEEEEF] hover:ring-2 hover:ring-[#f76266] hover:rounded-r-lg'>
<Trash2 className="w-8 h-6" strokeWidth={1.5} />
</div>
}
</div>
                </div>
                </> )
}
